<template lang="pug">
  fieldset.product-option
    legend.product-option__legend(v-if="label === 'Color'")
      span.product-option__legend--title Select {{ label }}      

    //- Color Swatches
    //- note: this is a duplication of the 'productSwatch' formatted in a different way.
    div.swatch__label-wrapper.color-selector(v-if="label === 'Color'")
      label.swatch__label(
        v-for="option in optionSet"
        tabindex="0",
        :style="getStyle(option.value)",
        :class="{ 'active': option.value === value, 'swatch__label--out-of-stock': optionIsOutOfStock(option.value) || allSizesOutOfStock(option.value) }"
        )
          input.u-sr-only(            
            type="radio"
            tabindex="-1"
            v-model="currentValue"
            :id="option.label"
            :value="option.value"
            :name="option"
            @change.prevent="onChange(option.value)"
          )
      span.product-option__legend--title(v-if="currentValue") Color: {{ currentValue }}

    //- Every other type of options -> in this case should be MATERIALS
    div.product-option__size__list.material.js-material(:class="bundleMaterial !== blank ? null : 'product-option__size__single'", v-if="label !== 'Color' && !isDropdown")
      template(v-for="option in optionSet")
        template(v-if="option.url !== blank")
          a.product-option__label(
            :data-title="bundleMaterial"
            :test="option.value"
            :test2="value"
            :href="bundleUrl") {{bundleMaterial}}
        template(v-else)
          label.product-option__label(
            tabindex="0"
            :data-title="option.value"
            :class="{ 'active': option.value === value, 'swatch__label--out-of-stock': optionIsOutOfStock(option.value) || allSizesOutOfStock(option.value) }"
            @click="$emit('is-selected-false')"
          ) {{ option.label }}
            input.u-sr-only(
              type="radio"
              tabindex="-1"
              v-model="currentValue"
              :id="option.label"
              :value="option.value"
              :name="option"
              @change.prevent="onChange(option.value)"
            )
    //- div(v-else-if="label !== 'Color' && isDropdown")
    //-   select-input.product-option__dropdown(
    //-     :options="dropdownOptions",
    //-     :value="value",
    //-     @input="onDropdownChange",
    //-     :required="true")

</template>

<script>
  import SelectInput from '../forms/SelectInput.vue';
  import { mapState } from 'vuex'

  export default {
    name: 'ProductOption',
    components:{
      SelectInput
    },
    props: {
      product: Object,
      label: String,
      value: String,
      isSelected: Boolean,
      option: {
        type: String,
        default: 'option1',
        validator (val) {
          return ['option1', 'option2'].includes(val)
        }
      },
      availableOptions: Array,
      colorsByOption: Array,
      showLabel: {
        type: Boolean,
        default: true
      },
      isDropdown: {
        type: Boolean,
        default: false
      },
      bundleUrl: String,
      bundleMaterial: String
    },
    data () {
      return {      
        dataLabel: '',
        currentValue: this.value,
        notSelected:false
      }
    },
    mounted () {
      if ( this.label == 'Color' || this.label == 'Material' || this?.optionSet?.length === 1 ){
        console.log(this.value, 'val');
        let initialValue = this.value && this.value !== '' ? this.value : this.optionSet[0].value;
        this.$emit('input', initialValue);              
      }
    },
    computed: {
      ...mapState({
        colors: state => state.swatchColors.colors
      }),
      optionSet () {
        console.log(this.colorsByOption, 'coloroption');
        
        let newOPtionSet = [...new Set(this.product.variants.slice().map(variant => variant[this.option]))]
          .map(option => ({ label: option, value: option }));

          if(this.label == 'Color'){
            let colors = this.colorsByOption;
            return newOPtionSet.filter(val => colors.includes(val.value));
          }
          else if(this.label == 'Material'){
            newOPtionSet.push({label:this.bundleMaterial, value:this.bundleMaterial, url:this.bundleUrl});
            newOPtionSet.sort((a,b) => {return a.label > b.label});
          }
          
          return newOPtionSet; 
      },
      swatch() {
        if(this?.colors){
          return this?.colors?.colors?.filter((color) => {
            return color.title === this.option.variant;
          });
        }
      },
      dropdownOptions () {
        return this.optionSet.map(option => ({ ...option, label: `${this.label}: ${option.value}` }))
      },
      currentColorValue(){

        let optionSetList = this.optionSet;

        if(!this.dataLabel && this.label === 'Color') {
          optionSetList.forEach(option => {
            if(!this.allSizesOutOfStock(option.value) && !this.dataLabel){
              this.dataLabel = option.value;
              this.currentValue  = option.value;
              return; 
            }
          }); 
        }
 
        return this.dataLabel;
      }
    },
    methods: {
      optionIsOutOfStock(value) {
        return !this.availableOptions.includes(value);
      },
      allSizesOutOfStock(value) {
        const variants = this.product.variants.filter((variant) => {
          return variant.option1 === value && variant.available;
        });
        
        return variants && variants?.length === 0;
      },
      sizeSelected (value) {
        this.$emit('childToParent', this.notSelected)
      },
      onChange (value) {
        this.$emit('input', value)
      },
      // onDropdownChange (value) {
      //   this.currentValue = value
      //   this.$emit('input', this.currentValue)
      // },
      getStyle(value){
        let swatch = {};
        // Set default to white swatch
        let style = {
          'backgroundColor': '#fffff',
          'backgroundPosition': 'center',
          'backgroundSize': 'cover'
        };

        if(this?.colors){
          swatch = this?.colors?.colors.filter((color) => {
            return color.title === value;
          });
        }
        
        if(swatch[0]){
          if (swatch[0]?.image?.length > 0) {
          //image swatch
          style = {
              'backgroundImage':`url(${swatch[0].image})`,
              'backgroundPosition': 'center',
              'backgroundSize': 'cover'
              }
          }
          else {
              style = {
                'backgroundColor': swatch[0].color_code
              }
          }
        } else {
          console.warn(`Warning: missing settings for swatch ${value}`)
        }

        return style;
      },
    }
  }
</script>

<style scoped lang="scss">
  .product-option {
    border: none;
    padding: 0;   
  }

  fieldset { 
    width: 100%;
    margin-bottom: 44px;

    &:last-child {
      margin-bottom: 50px;
    }

  }
  
  .swatch__label {
    &-wrapper {
      display: flex;
      height: 20px;
    }

    cursor: pointer;
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 16px;
    position: relative;
    border-radius: 50%;
    border: 1px solid #161616;

    &.active, &:focus {
      border: solid 1px #ffffff;

      &:after {
        content: '';
        position: absolute;
        top: -5px;
        right: -5px;
        bottom: -5px;
        left: -5px;
        transform: none;
        height: auto;
        width: auto;
        border-radius: 50%;
      }
    }

    &.swatch__label--out-of-stock,
    &.is-disabled,
    &:disabled {
      opacity: .5;

      &::before {
        content: '';
        display: block;
        width: 1px;
        height: 44px;
        background-color: white;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        margin: auto;
        transform: rotate(-45deg);
      }
    }

    &.is-disabled,
    &:disabled {
      pointer-events: none;
    }
  }

  .product-option {
    
    &__legend {
      &--title {
        font-family: 'basiersquare'; 
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.57;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        margin-bottom: 10px;
        display: flex;
      }
    }

    &__size {
      &__list {

        &.material {
          border-radius: 3px;
          padding: 2px;
          display: flex;
          border: solid 1px #494949;
          a,
          label {
            width: 50%;
            height: 52px; 
            color: #e1dace;
            font-family: 'basiersquare'; 
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.57;
            letter-spacing: normal;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            cursor: pointer;           
            text-decoration: none;

            &.active {
              border-radius: 3px;
              background-color: #212121;
              color: #fff;
            }
          }
        }
      }
      &__single{
        width:50%;
        &.material{
          a{
            display:none;
          }
          label{
            width:100%;
          }
        }
      }
    }
  }

  .u-sr-only {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important; /* 1 */
    -webkit-clip-path: inset(50%) !important;
      clip-path: inset(50%) !important; /* 2 */
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
    white-space: nowrap !important; /* 3 */
  }

</style>
